import { render } from "./DoneDepositing.vue?vue&type=template&id=791d89b6&scoped=true"
import script from "./DoneDepositing.vue?vue&type=script&lang=js"
export * from "./DoneDepositing.vue?vue&type=script&lang=js"

import "@/Common/Styles/depositReview.scss?vue&type=style&index=0&id=791d89b6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791d89b6"]])

export default __exports__